import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function UpgradePrompt({
  title = "Upgrade required",
  message = "This feature is available on a higher plan.",
  ctaLabel = "View plans",
  compact = false,
}) {
  const location = useLocation();

  return (
    <div
      className={
        compact
          ? "rounded-xl border border-indigo-200 bg-indigo-50 px-3 py-2 text-sm text-indigo-900"
          : "rounded-2xl border border-indigo-200 bg-indigo-50 p-4 text-sm text-indigo-900"
      }
    >
      <div className="font-semibold">{title}</div>
      <div className="mt-1">{message}</div>

      <Link
        to={`/upgrade?from=${encodeURIComponent(location.pathname)}`}
        className="mt-3 inline-flex items-center rounded-xl border border-indigo-300 bg-white px-3 py-2 text-sm font-medium text-indigo-700 hover:bg-indigo-100"
      >
        {ctaLabel}
      </Link>
    </div>
  );
}